import { createApp } from "vue";
import router from "./router";
import "element-plus/dist/index.css";
import App from "./App.vue";
import "../src/assets/style.scss";
// main.js
import lazyPlugin from "vue3-lazy";

import dataV from "@jiaminghi/data-view";
// import DataV, { setClassPrefix } from "@dataview/datav-vue3";

import scrollBarVal from "@/components/scrollBar.vue";

let app = createApp(App);
app.use(lazyPlugin, {
  loading: "@/assets/lo.gif", //图片加载中时显示的默认图片
  error: "@/assets/error.png",
});
app.component("scrollBarVal", scrollBarVal);
app.use(router);
app.use(dataV);

app.mount("#app");
